export default "__VITE_ASSET__624cea7a__"